import { useMemo } from 'react';
import { IDataPackageFileDescriptor } from '@vivli/shared/features/data-package/infrastructure/interface';
import { IUser } from '@vivli/shared/infrastructure/interface';

export const useOrgFiles = (files: IDataPackageFileDescriptor[], user: IUser, viewAll = false) => {
    return useMemo(() => {
        if (files === null) {
            // data package failed to load, return empty array
            return [];
        }

        if (viewAll) {
            return files;
        }

        return files?.filter((f) => user.orgMemberships?.some((o) => o.orgId === f.organizationId && o.isEnabled));
    }, [files]);
};
